import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { cloneDeep } from 'lodash'
import { FileShareTabType } from './types/FileShareEnums'

// types

interface ICurrentBatch {
  root: FileShareTabType
  refresh?: boolean
}

const fileShareSliceInitialState = {
  root: FileShareTabType.Files,
  refresh: false,
} as ICurrentBatch

export const fileShareSlice = createSlice({
  name: 'files',
  initialState: fileShareSliceInitialState,
  reducers: {
    updateCurrentFiles(state: ICurrentBatch, action: PayloadAction<ICurrentBatch>) {
      state.root = cloneDeep(action.payload.root)
      state.refresh = cloneDeep(action.payload.refresh)
    },
  },
})

export const { updateCurrentFiles } = fileShareSlice.actions

export const fileShareReducer = fileShareSlice.reducer
